import React from 'react';
import Skeleton from '@atlaskit/skeleton';

export const ContentStateSkeleton = (): React.JSX.Element => (
	<Skeleton width="60px" height="20px" isShimmering testId="content-state-skeleton" />
);
